import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Stations = lazy(() => import('./stations'));

export function StationsPage() {
  return (
    <article className="space-y-6" data-testid="stations-page">
      <Suspense fallback={<Loading />}>
        <Stations />
      </Suspense>
    </article>
  );
}
